<script setup lang="ts">
import type { CmsElementStepsBox } from "~/composables/useCustom";

const props = defineProps<{
  content: CmsElementStepsBox;
  class: any;
  style: any;
}>();

const { heading, stepsCollection } = props.content?.config

</script>
<template>
  <section class="section section-main section-steps" :style="props.style" :class="props.class">
    <div class="container">
      <header class="section__head">
        <h2>{{ heading.value }}</h2>
      </header><!-- /.section__head -->

      <div class="section__body">
        <ul class="steps">

          <li class="step" v-for="(step, index) in stepsCollection.value">
            <div class="step__inner">
              <div class="step__count">
                <img height="75" :src="'/assets/images/svg/' + step.position + '.svg'" alt=""></img>
              </div><!-- /.step__count -->

              <div class="step__content">
                <div class="step__icon">
                  <i class="ico-balloon">
                    <img height="100" loading="lazy"  format="webp" :src="step.icon?.url" alt=""></img>
                  </i>
                </div><!-- /.step__icon -->

                <p v-html="step.text" />
              </div><!-- /.step__inner -->
            </div><!-- /.step__inner -->
          </li><!-- /.step -->

        </ul><!-- /.steps -->
      </div><!-- /.section__body -->
    </div><!-- /.container -->
  </section>
</template>